import React from 'react';
import { ScaleLoader } from 'react-spinners';
import styled from 'styled-components';
import LogoIcon from './LogoIcon';
import Spacer from './Spacer';

const Container = styled.div<{ full: boolean }>`
  display: flex;
  width: 100%;
  ${(props) => (props.full ? 'height: 100vh;' : '')}
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ErrorTitle = styled.div`
  color: #384277;
  font-size: 14px;
  font-weight: 500;
`;

const ErrorMessage = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #384277;
`;

const LogoButton = styled.a`
  padding: 10px;
  display: inline-flex;
  border-radius: 5px;
  transition: all 0.2s;
  &:hover {
    background: #f4f5ff;
  }
`;

type Props = {
  loading: boolean;
  full?: boolean;
  error?: {
    title?: string;
    helpText?: string;
  };
};

export default function Loader({ loading, full = false, error }: Props) {
  const [load, setLoad] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setLoad(true);
    }, 200);
  }, [loading]);

  if (!load) {
    return null;
  }

  return (
    <Container full={full}>
      <LogoButton href={'https://paypi.dev'}>
        <LogoIcon height={'15px'} color={'#5C6EF8'} />
      </LogoButton>
      <Spacer vertical spacing={3} />
      {!error && <ScaleLoader color={'#e4e4e6'} height={14} />}
      {!!error && (
        <>
          <ErrorTitle>
            {error.title ?? 'Oops, there was an error while loading the page'}
          </ErrorTitle>
          <ErrorMessage>
            {error.helpText ?? 'Please reload and try again'}
          </ErrorMessage>
        </>
      )}
    </Container>
  );
}
